<template>
  <div id="index">
    <div class="simple-bg" v-if="isWxRegister">
      <router-view v-if="redirectURI" :redirectURI="redirectURI" />
    </div>
    <template v-else>
      <vue-particles class="bg" color="#dedede"></vue-particles>
      <div class="rectangle">
        <router-view v-if="redirectURI" :redirectURI="redirectURI" />
        <div class="cover" :style="`backgroundImage: url(https://cdn.lessonplan.cn/Passport/IMG/${$route.name}-cover.png)`"></div>
      </div>
    </template>
  </div>
</template>

<script>
import { getRedirectURI } from '../../util/url'

export default {
  name: 'index',
    data() {
      return {
        redirectURI: '',
      }
    },
  computed: {
    isWxRegister() {
      return this.$route.name === 'wxRegister'
    }
  },
  async mounted() {
    const redirectURI = getRedirectURI()
    this.redirectURI = redirectURI

    const verifyRet = await this.$api.passport.verifyToken()
    if(verifyRet.status === 1) location.href = redirectURI
  }
}
</script>

<style lang="scss" scoped>
#index{
  height: 100%;
  box-sizing: border-box;
  background-color: #63969d;
  display: flex;
  justify-content: center;
  align-items: center;

  ::v-deep .record {
    width: 100%;
    margin: 0 auto;
    padding: 0 15px;
    position: absolute;
    bottom: 12px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      color: #939393;
      text-decoration: unset;
    }
  }
}
.simple-bg {
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.bg{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.rectangle{  
  width: 80%;
  height: 88%;
  background-color: #fff;
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, .15);
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.cover{
  background-size: cover;
  background-position: left center;
}

/* 移动设备 */
@media only screen and (max-width: 720px) {
  .rectangle{  
    width: 100%;
    height: 100%;
    border-radius: 0;
    box-shadow: none;
    grid-template-columns: 1fr;
  }
  .cover{
    display: none;
  }
}
</style>